import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Fade from '../Fade/index.js';

/**
 * LoadingIndicator is similar to AjaxSpinner as it can be used to signal to a user that an asynchronous action is in progress.
 * The difference it that LoadingIndicator will obscure the section that is to be updated with a transparent overlay.
 * To use LoadingIndicator just wrap the content you wish to identify as updating with the component.  Passing props.show={true} to LoadingIndicator
 * will cause the animated overlay to display.  The speed of the animation to show the overlay can be slowed by passing
 * props.slow={true}
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingIndicator(_ref) {
  let {
    className,
    show = false,
    slow = false,
    fixed,
    children,
    ...rest
  } = _ref;
  const containerClassName = clsx({
    'loading-indicator': true,
    fixed,
    slow
  }, className);
  return /*#__PURE__*/_jsx(Fade, {
    in: show,
    children: /*#__PURE__*/_jsx("div", {
      "data-cmp": "loadingIndicator",
      ...rest,
      className: containerClassName,
      children: children
    })
  });
}
export default LoadingIndicator;